import styled from "styled-components";

export const MainHeader = styled.section`
  /* width: 100%; */
  /* background-color: pink; */
  display: flex;
  height: 600px;
  margin-top: 120px;
  margin-bottom: 10rem;
  position: relative;
  @media (max-width: 1440px) {
    /* scale: 0.8; */
    padding-right: 10rem !important;
  }
  @media (max-width: 1300px) {
    margin-top: 0rem;
  }
  @media (max-width: 1024px) {
    margin-top: -5rem;
    padding: 0 3rem !important;
    margin-bottom: 0rem;
  }
`;
export const TextContainer = styled.div`
  width: ${(props) => props.width};
  width: 520px;
  margin-top: 2rem;
  p {
    font-family: 50rem;
    font-size: 1.6rem;
    line-height: 3rem;
    color: var(--text-color);
  }
  @media (max-width: 760px) {
    width: ${(props) => (props.textBreak ? "552px" : "353px")};
    margin-right: 3rem;
  }
  @media (max-width: 570px) {
    width: ${(props) => props.textBreak && "353px"};
  }
`;
export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  margin-top: 100px;
  h2 {
    position: relative;
    font-size: 6.4rem;
    font-weight: 80rem;
    color: var(--primary-color);
    margin-bottom: 2rem;
    &::before {
      position: absolute;
      content: "";
      width: 218px;
      height: 50px;
      background-image: url("TitleVector.svg");
      background-repeat: no-repeat;
      z-index: -1;
      right: -142px;
      top: 20px;
    }
  }

  input {
    height: 45px;
    width: 95%;
    border-radius: 5px;
    outline: none;
    border: none;
    border: 2px solid var(--border-color);
    padding: 10px;
    padding-right: 1rem;
    ::placeholder {
      color: var(--title-color);
      font-size: 2rem;
      font-weight: 600;
      font-family: "Yekan-Bakh-Regular";
      padding-right: 1.2rem;
    }
  }

  @media (max-width: 1516px) {
    scale: 0.8;
  }

  @media (max-width: 1300px) {
    margin-top: 0rem;
  }

  @media (max-width: 1024px) {
    margin-top: 0%;
    h2 {
      font-size: 42px;
      margin-top: 0%;
      &::before {
        /* width: 50px; */
        background-size: 186px 26px;
        top: 13px;
      }
    }
    form {
      display: none;
    }
  }

  @media (max-width: 760px) {
    h2 {
      &::before {
        right: -125px;
      }
    }
  }
`;
export const MainHeaderBtnContainer = styled.div`
  position: relative;
  width: 100%;
  /* background-color: pink; */
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    z-index: 1;
  }
  img {
    position: absolute;
    mix-blend-mode: multiply;
    right: 200px;
  }
  @media (max-width: 1024px) {
    button {
      scale: 0.7;
    }
    img {
      scale: 0.5;
      right: 5px;
    }
  }
`;
export const ImgWrapper = styled.div`
  width: 20%;
  position: absolute;
  top: 40%;
  right: 40%;
  img {
    width: 100%;
    display: block;
  }
`;
